import { loading, handleErrorException, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getConfiguration = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_CONFIGURATION_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `SISIntegration/Aeries/Configuration`
      );

      dispatch(
        success(types.AERIES_GET_CONFIGURATION_SUCCESS, response.data.Data)
      );
    } catch (error) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching the configuration. Please try again.',
      };
      dispatch(
        handleErrorException(
          error,
          types.AERIES_GET_CONFIGURATION_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.AERIES_CONFIGURATION_LOADING, false));
    }
  };
};
export const saveConfiguration = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_CONFIGURATION_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `SISIntegration/Aeries/Configuration`,
        model
      );

      dispatch(
        success(types.AERIES_WRITE_CONFIGURATION_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.AERIES_WRITE_CONFIGURATION_ERROR, {
          Title: 'Error',
          Message: 'Unable to save Aeries integration configuration.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_CONFIGURATION_LOADING, false));
    }
  };
};

export const getMappings = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_MAPPINGS_LOADING, true));

      const response = await MPWWebApi.getGeneric(
        `SISIntegration/Aeries/Mappings`
      );

      dispatch(success(types.AERIES_GET_MAPPINGS_SUCCESS, response.data.Data));
    } catch (error) {
      dispatch(
        handleErrorException(error, types.AERIES_GET_MAPPINGS_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Aeries integration mappings.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_MAPPINGS_LOADING, false));
    }
  };
};

export const getPreview = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_PREVIEW_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `SISIntegration/Aeries/Preview`,
        model
      );

      dispatch(success(types.AERIES_GET_PREVIEW_SUCCESS, response.data.Data));
    } catch (error) {
      dispatch(
        handleErrorException(error, types.AERIES_GET_PREVIEW_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Aeries integration student preview.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_PREVIEW_LOADING, false));
    }
  };
};

export const importStudent = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_IMPORT_STUDENT_LOADING, true));

      await MPWWebApi.postGenericInsertUpdate(
        `SISIntegration/Aeries/ImportStudent`,
        model
      );

      dispatch(setPreviewImportSuccessful(true));
    } catch (error) {
      dispatch(
        handleErrorException(error, types.AERIES_IMPORT_STUDENT_ERROR, {
          Title: 'Error',
          Message: 'Unable to import student.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_IMPORT_STUDENT_LOADING, false));
    }
  };
};

export const saveMappings = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_MAPPINGS_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `SISIntegration/Aeries/Mappings`,
        model
      );

      dispatch(
        success(types.AERIES_WRITE_MAPPINGS_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.AERIES_WRITE_MAPPINGS_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Aeries integration mappings.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_MAPPINGS_LOADING, false));
    }
  };
};

export const getLanguages = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric(`Language`);
      dispatch(success(types.AERIES_GET_LANGUAGES_SUCCESS, response.data.Data));
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.AERIES_GET_LANGUAGES_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Aeries integration languages.',
        })
      );
    } finally {
      dispatch(loading(types.AERIES_GET_LANGUAGES_LOADING, false));
    }
  };
};

export const getManualSync = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.AERIES_MANUAL_SYNC_LOADING, true));
      dispatch(setManualSyncComplete(false));

      await MPWWebApi.getGeneric(`SISIntegration/Aeries/ManualSync`);

      dispatch(success(types.AERIES_MANUAL_SYNC_STARTED));
    } catch (error) {
      dispatch(loading(types.AERIES_MANUAL_SYNC_LOADING, false));
      dispatch(
        handleErrorException(error, types.AERIES_MANUAL_SYNC_ERROR, {
          Title: 'Error',
          Message: 'Unable to get Aeries integration student preview.',
        })
      );
    }
  };
};

export const setConfigurationSaveSuccessful = (successful) => {
  return {
    type: types.AERIES_CONFIGURATION_SET_SAVE_SUCCESSFUL,
    payload: successful,
  };
};

export const setMappingsSaveSuccessful = (successful) => {
  return {
    type: types.AERIES_MAPPINGS_SET_SAVE_SUCCESSFUL,
    payload: successful,
  };
};

export const clearConfigurationErrors = () => {
  return {
    type: types.AERIES_CONFIGURATION_CLEAR_ERRORS,
  };
};

export const clearMappingsErrors = () => {
  return {
    type: types.AERIES_MAPPINGS_CLEAR_ERRORS,
  };
};

export const setPreviewImportSuccessful = (successful) => {
  return {
    type: types.AERIES_IMPORT_STUDENT_SET_SAVE_SUCCESSFUL,
    payload: successful,
  };
};

export const clearPreviewErrors = () => {
  return {
    type: types.AERIES_PREVIEW_CLEAR_ERROR,
  };
};

export const resetPreview = () => {
  return {
    type: types.AERIES_PREVIEW_RESET,
  };
};

export const setManualSyncComplete = (isComplete) => {
  return {
    type: types.AERIES_MANUAL_SYNC_MANUAL_SYNC_COMPLETE,
    payload: isComplete,
  };
};

export const setManualSyncLoading = (isLoading) => {
  return {
    type: types.AERIES_MANUAL_SYNC_LOADING,
    payload: isLoading,
  };
};

export const clearManualSyncErrors = () => {
  return { type: types.AERIES_MANUAL_SYNC_CLEAR_ERRORS };
};



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/state/actions.js